import { BaseResolver } from "@nx/typescript-domain";
import { ICaseConversionService } from "./CaseConversion/ICaseConversionService";
import { IExportGeneratorService } from "./ExportGenerators/IExportGeneratorService";
import { IExportProfileService } from "./ExportProfiles/IExportProfileService";
import { IImportExampleService } from "./ImportExamples/ImportExampleService";
import { IModelInfoService } from "./ModelInfos/IModelInfoService";
import { IParserService } from "./Parsers/ParserService";

class Domain extends BaseResolver {
    public get parserService() { return this.resolve<IParserService>("IParserService"); }
    public get importExampleService() { return this.resolve<IImportExampleService>("IImportExampleService"); }
    public get modelInfoService() { return this.resolve<IModelInfoService>("IModelInfoService"); }
    public get exportGeneratorService() { return this.resolve<IExportGeneratorService>("IExportGeneratorService"); }
    public get caseConversionService() { return this.resolve<ICaseConversionService>("ICaseConversionService"); }
    public get exportProfileService() { return this.resolve<IExportProfileService>("IExportProfileService"); }
}
export const domain = new Domain();

export const translate = (key: string) => key;
